var BillType;
(function (BillType) {
    BillType["AutoPay"] = "AUTO_PAY";
    BillType["PayOnce"] = "PAY_ONCE";
})(BillType || (BillType = {}));
var CurrencyCode;
(function (CurrencyCode) {
    CurrencyCode["Usd"] = "USD";
    CurrencyCode["Cad"] = "CAD";
})(CurrencyCode || (CurrencyCode = {}));
var BillCategory;
(function (BillCategory) {
    BillCategory["Hdc1Dot0"] = "HDC1DOT0";
    BillCategory["Hdc1Dot5"] = "HDC1DOT5";
    BillCategory["Insurance"] = "INSURANCE";
})(BillCategory || (BillCategory = {}));
var BillStatus;
(function (BillStatus) {
    BillStatus["Failed"] = "FAILED";
    BillStatus["Ok"] = "OK";
    BillStatus["PastDue"] = "PAST_DUE";
})(BillStatus || (BillStatus = {}));

export { BillCategory, BillStatus, BillType, CurrencyCode };
